import { createUseStyles } from 'react-jss'

import { LightTheme } from '../../theme'

import { TextPropsWithColor } from './text.types'

const colorByProps =
  (theme: LightTheme, defaultColor?: string) => (props: TextPropsWithColor) =>
    theme.colors[props.color] || defaultColor || theme.colors.black

export const useStyle = createUseStyles((theme: LightTheme) => ({
  mainBanner: {
    ...theme.typography.mainBanner,
    color: colorByProps(theme)
  },
  secondBanner: {
    ...theme.typography.secondBanner,
    color: colorByProps(theme)
  },
  h1: {
    ...theme.typography.h1,
    color: colorByProps(theme)
  },
  h2: {
    ...theme.typography.h2,
    color: colorByProps(theme)
  },
  h3: {
    ...theme.typography.h3,
    color: colorByProps(theme)
  },
  h4: {
    ...theme.typography.h4,
    color: colorByProps(theme)
  },
  h5: {
    ...theme.typography.h5,
    color: colorByProps(theme)
  },
  h6: {
    ...theme.typography.h6,
    color: colorByProps(theme)
  },
  h7: {
    ...theme.typography.h7,
    color: colorByProps(theme)
  },
  h1Mobile: {
    ...theme.typography.h1Mobile,
    color: colorByProps(theme)
  },
  h2Mobile: {
    ...theme.typography.h2Mobile,
    color: colorByProps(theme)
  },
  h3Mobile: {
    ...theme.typography.h3Mobile,
    color: colorByProps(theme)
  },
  title: {
    ...theme.typography.title,
    color: colorByProps(theme)
  },
  subscriptionText: {
    ...theme.typography.subscriptionText,
    color: colorByProps(theme)
  },
  maxButton: {
    ...theme.typography.maxButton,
    color: colorByProps(theme)
  },
  cardText: {
    ...theme.typography.cardText,
    color: colorByProps(theme, theme.colors.white)
  },
  body: {
    ...theme.typography.body,
    cursor: 'default',
    color: colorByProps(theme)
  },
  secondTitle: {
    ...theme.typography.secondTitle,
    color: colorByProps(theme)
  },
  button: {
    ...theme.typography.button,
    color: colorByProps(theme, theme.colors.white)
  },
  rightButton: {
    ...theme.typography.rightButton,
    color: colorByProps(theme)
  },
  notFound: {
    ...theme.typography.notFound,
    color: colorByProps(theme)
  },
  italicSecondTitle: {
    ...theme.typography.italicSecondTitle,
    color: colorByProps(theme)
  },
  bannerDescription: {
    ...theme.typography.bannerDescription,
    color: colorByProps(theme)
  },
  h4Mobile: {
    ...theme.typography.h4Mobile,
    color: colorByProps(theme)
  }
}))
